module.exports = __webpack_public_path__ + "img/title-pro.d8651aa6.png";